<template>
  <div class="item row-between" @click="toQuestions">
    <div class="flex1 row areaName">{{ areaName2[language] }}</div>
    <div>
      <svg-icon
        iconClass="arrow-right-circle"
        style="width: 22px; height: 22px"
        v-if="item.wrongInspection === null"
      ></svg-icon>
      <svg-icon
        iconClass="green-right"
        style="width: 22px; height: 22px"
        v-if="item.wrongInspection === 0"
      ></svg-icon>
      <div class="wrong center" v-if="item.wrongInspection">
        {{ item.wrongInspection }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AreaItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    roomNumber: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      language: "language",
    }),
  },
  data() {
    return {
      areaName2: {},
    };
  },
  watch: {
    item: {
      handler(newValue) {
        if (newValue && newValue.areaName2) {
          this.areaName2 = JSON.parse(newValue.areaName2);
          console.log("this.areaName2", this.areaName2);
        }
      },
      immediate: true,
    },
  },
  methods: {
    toQuestions() {
      this.$router.push({
        name: "InspectRoomQuestions",
        query: {
          dataForm: JSON.stringify({
            areaId: this.item.areaId,
            areaName: this.areaName2[this.language],
            roomNumber: this.roomNumber,
            inspectionItemResponseList: this.item.inspectionItemResponseList,
          }),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  width: 48%;
  border-radius: 6px;
  padding: 12px;
  background: #ededed;
  margin-bottom: 16px;

  .areaName {
    font-size: 16px;
    line-height: normal;
    color: #101010;
    text-align: left;
  }

  .wrong {
    height: 22px;
    background: #cb4e4e;
    padding: 0 8px;
    border-radius: 11px;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
  }
}
</style>
